export default "__VITE_ASSET__xX66HRDA__"